import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Text from '../../Text/Text';
import { Section, SectionContainer } from '../../Section';
import HeroButton from '../Hero/HeroButton';
import Grid from '../../Grid/Grid';
import Styles from './CallToAction.module.scss';

// don't have state or refs, prefer normal functions (not arrow functions) over classes: airbnb styleguide

const EnterpriseCta = ({ talent, ...props }) => {
  return (
    <SectionContainer type={SectionContainer.Type.ENTERPRISE} id='cta-box'>
      <Section className={Section.Styles.innerContainerSection}>
        <Grid columns={2} className={Section.Styles.gridContainer}>
          <Grid.Item>
            <Text
              size={Text.Size.SUBHEADLINE}
              variation={Text.Variation.WHITE}>{`Hire the best ${talent} today`}</Text>
            <Text element='p' variation={Text.Variation.WHITE}>
              {`Get in touch today. We can provide you with the most qualified 
                ${talent} or experts to meet your project needs.`}
            </Text>
          </Grid.Item>
          <Grid.Item>
            <div className={Styles.buttons}>
              <HeroButton
                type={HeroButton.Type.WHITE}
                title='Work with Talents'
                to={`/enterprise/register`}>
                {`Contact Us`}
              </HeroButton>
            </div>
          </Grid.Item>
        </Grid>
      </Section>
    </SectionContainer>
  );
};

EnterpriseCta.propTypes = {
  talent: PropTypes.string,
  className: PropTypes.string,
};

EnterpriseCta.defaultProps = {
  talent: 'talents',
};

export default EnterpriseCta;
